import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../app-services/config/config.app';
import { AppMonitoring } from '../../app-services/monitoring/monitor.app';
import { Enums } from '../../enums/enums';
import { AbstractEndpoints } from '../endpoints/endpoints.service.abstract';
import { ServiceAzureStorage } from './azure-storage.service';
import { MockServiceAzureStorage } from './azure-storage.service.mock';

export function FactoryServiceAzureStorage(http: HttpClient, endpoints: AbstractEndpoints, appMonitoring: AppMonitoring, appConfig: AppConfig) {
    appMonitoring.logEvent('FactoryServiceAzureStorage', 'Azure Storage Service Factory loaded');
    switch (appConfig.environment) {
        case Enums.Environments.MockData:
        case Enums.Environments.MockDataWithAuth:
            return new MockServiceAzureStorage();
        default:
            return new ServiceAzureStorage(endpoints, http, appConfig)
    }
}
